export const DestinationMapVisibility = {
    HIDDEN: 0,
    HIGHEST_ZOOM: 1,
    HIGH_ZOOM: 2,
    MEDIUM_ZOOM: 3,
    LOW_ZOOM: 4,
    ALL_ZOOM_LEVELS: 5,
} as const;
